import { defineMessages } from 'react-intl';

export default defineMessages({
  yourInformation: 'Your information',

  yourVotingPower: 'Your voting power',
  yourPropositionPower: 'Your proposition power',
  delegateYourPower: 'Delegate your power',
  delegate: 'Delegate',
  noWalletTitle: 'Please connect a wallet to see your information',

  yourDelegations: 'Your delegations',
  propositionPower: 'Proposition power',
  votingPower: 'Voting power',
});
